<template>
  <main works-list>
    <section class="hero">
      <h2>Works</h2>
      <div class="categories">
        <ScrollMenu :key="`scroll-menu-${code}`">
          <div class="swiper-slide" v-for="item in categories" :key="`scroll-menu-${code}-${item.code}`">
            <locale-link :to="item.data.route" :class="{ on: checkOn(item) }">{{ item.label }}</locale-link>
          </div>
        </ScrollMenu>
      </div>
    </section>
    <section class="list">
      <ul>
        <li v-for="(item, i) in list" :key="i">
          <a @click="linkTo(`/works/article/${item.slug}`)">
            <div class="img">
              <cdn-img :src="item.image"/>
            </div>
            <div class="text">
              <p v-html="enterToBr(item.title)"></p>
              <p v-html="enterToBr(item.description)"></p>
            </div>
          </a>
        </li>
      </ul>
      <div class="view-more" v-if="paging.pageNo < paging.pageCount">
        <a @click="getList"><i></i><span>VIEW MORE</span><span v-if="false">{{ paging.pageNo }}/{{ paging.pageCount
          }}</span></a>
      </div>
    </section>
  </main>
</template>

<script>
import oax from '@/utils/oax';
import CdnImg from '@/views/components/CdnImg';
import ScrollMenu from '@/views/components/ScrollMenu';

export default {
  name: 'works-list',
  components: { ScrollMenu, CdnImg },
  data() {
    return {
      code: null,
      list: null,
      paging: null,
    };
  },
  computed: {
    category() {
      return this.$route.params.category;
    },
    categories() {
      // return [{ label: 'All', data: { route: `/works/all` } }, ...this.codeList('works')];
      return this.codeList('works');
    },
    activeIndex() {
      return this.categories.findIndex(row => row.data.route.includes(this.category));
    },
    description() {
      if (this.category === 'all') return this.codeData(this.root)?.description || '';
      return this.categories.find(row => row.data.route.includes(this.category))?.data?.description || '';
    },
  },
  watch: {
    code: 'refresh',
  },
  methods: {
    refresh() {
      // console.log(this.activeIndex);
      //this.$refs.slider.go(this.activeIndex);
    },
    checkOn(item) {
      return this.$route.path === `${ this.$i18n('path') }${ item.data.route }`;
    },
    changedSlider(e) {
      const route = this.categories[e.realIndex].data.route;
      if (!this.$route.path.includes(route)) this.localeLink(route);
    },
    async getList() {
      const { data } = await oax.get(`/api/article`, {
        lang: this.lang,
        category: this.code,
        perPage: 12,
        pageNo: this.paging.pageNo + 1,
      });
      this.list = [...this.list, ...data.list];
      this.paging = data.paging;
    },
  },
  mounted() {
    this.$store.commit('theme', 'default');
  },
  async asyncData({ route, store }) {
    const lang = route.params.locale || 'ko';
    const path = route.path.replace('/all', '').replace(`/${ lang }`, '');
    const category = store.state.codes.find(row => row.data.route === path)?.code;
    if (!category) throw new Error('404');
    const info = (await oax.get(`/api/article`, { lang, category, perPage: 12 })).data;
    if (!info) throw new Error('404');

    return { list: info.list, paging: info.paging, code: category };
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";

[works-list] {
  section { .space-m;
    &.hero { .pt(78);
      h2 { .fs(60, 80); .regular; }
      .categories { .mt(33); .ph(20); .mh(-20); .crop;
        .locked .swiper-slide:last-of-type {.mr(0);}
        .swiper-slide { .p; overflow: hidden;
          a { .fs(18, 32); .block; .medium; .-b(transparent);
            &.on { .-b(#000); }
          }
        }
        .hidden-ml-down { .fs(0,0); }
      }
    }
    &.list { .rel;
      > ul { .rel; .pt(35); display: grid; grid-template-columns: 1fr; row-gap: 50px;
        > li {.rel;
          .img { aspect-ratio: 16 / 9; .crop; }
          [cdn-img] { .rel; .f; object-fit: cover; transform: scale(1); .o(1); transition: transform 1s cubic-bezier(0, 0, 0.13, 1.04), opacity .6s ease;}
          .text { .mt(20);
            p { .fs(24, 30); }
            p + p { .mt(12); .fs(16, 24, -0.25); }
          }
          .no-touch &:hover {
            [cdn-img], video {transform: scale(1.1);}
            &.has-video [cdn-img] { .o(0); }
          }
        }
      }
      .view-more { .tc; .pt(80);
        a { .rel;
          i { .wh(28); .ib; .vam; .contain; .no-repeat; .bg('/img/common/view-more.svg');}
          span { .ib; .vam; .fs(20, 30); .medium;
            &:first-of-type {.mh(20);}
          }
          &:after {content: ''; .abs; .w(0); .h(2); .bgc(#fff); .lb(0, -10); transition: width .6s cubic-bezier(0.4, -0.03, 0, 1.03);}
          .no-touch &:hover {
            &:after { .wf; }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-tp-min) {
  [works-list] {
    section {
      &.list {
        > ul > li {
          .text { display: grid; grid-template-columns: 1fr 1fr; column-gap: 10px; .mt(16);
            p + p { .mt(0); }
          }
        }
        .view-more { .pt(100); }
      }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [works-list] {
    section {
      &.list {
        > ul { grid-template-columns: 1fr 1fr; column-gap: 20px;
          > li {
            .text { .block;
              p + p { .mt(8); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [works-list] {
    section { .space-d;
      &.hero { .pt(112);
        h2 { .fs(100, 1); }
        .categories { .mt(50); .ph(40); .mh(-40);
          .swiper-slide {
            a { .fs(24, 32); }
          }
        }
      }
      &.list {
        > ul { column-gap: 40px; .pt(55);
          > li {
            .text { .mt(20);
              p {.fs(28, 34); }
              p + p { .mt(8); .fs(18, 28, -0.25); }
            }
          }
        }
        .view-more { .pt(100);
          a {
            span { .fs(24, 30); }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [works-list] {
    section {
      &.hero { .pt(150);
        h2 { .fs(120, 1); }
      }
      &.list {
        > ul { row-gap: 70px;
          > li {
            .text { .mt(32);
              p { .fs(32, 40); }
              p + p { .mt(12); .fs(20, 30, -0.25); }
            }
          }
        }
      }
      &.list {
        .view-more { .pt(160); }
      }
    }
  }
}

</style>